<template>
  <div>
    <div v-active-touch class="language-selector interactive-text" @click="showLang = true" v-if="webLangOptions?.length > 0">
      <LanguageIcon class="language-select-icon" />

      <div class="custom-select">
        {{ langList[this.$i18n.locale] }}
      </div>

      <TriangleDownIcon class="triangle-down" />
    </div>

    <Popup :title="$t('m.langBoxTitle')" :showPopup="showLang" @hidePopup="showLang = false" >
      <div style="padding: 0 23px;">
        <div v-for="(lang, index) in langList" :key="index"
           class="modal-option interactive-text"
           :class="{ selected: lang === langList[$i18n.locale] }"
           v-active-touch
           @click="changeLang(index)"
           >
              {{ lang }}
          </div>
      </div>
    </Popup>
  </div>
</template>

<script>
import {cks} from "../utils/tool";
import {langOptions} from "../common/lang";
import Popup from './popups/Popup.vue';
import LanguageIcon from './icons/LanguageIcon.vue';
import TriangleDownIcon from './icons/TriangleDownIcon.vue';

export default {
  name: 'LanguageSelector',
  components: { Popup, LanguageIcon, TriangleDownIcon },
  data() {
    return {
        langList: [], // 最终可用语言列表
        webLangOptions: [], // 后端指定要显示的语言
        showLang: false,
    };
  },
  created() {
    this.initLangOptions();
  },
  methods: {
    initLangOptions() {
      let useLangOptions = langOptions;
      let webLangOptions = this.$store.getters['appConfig/web_lang_options'];
      this.webLangOptions = webLangOptions;

      if (webLangOptions && webLangOptions.length > 0) {
        let items = {};
        for (let item of webLangOptions) {
          items[item] = langOptions[item];
        }
        useLangOptions = items;
      }

      // 如果当前语言不在选项里，就切到第一个
      if (!useLangOptions[this.$i18n.locale]) {
        const firstLang = Object.keys(useLangOptions)[0];
        if (firstLang) {
          this.$i18n.locale = firstLang;
          cks.set("lang", firstLang);
        }
      }

      this.langList = useLangOptions;
    },
    changeLang(lang) {
      this.$i18n.locale = lang
      this.showLang = false
      cks.set("lang", lang)
    }
  }
};
</script>

<style scoped lang="scss">
.language-selector {
  height: 36px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0px;
  border-top: 1px solid #E6E6E6;
}

.language-select-icon {
  width: 13px;
  height: 13px;
  margin-right: 7px;
  margin-bottom: 2px;
}

.triangle-down {
  height: 6px;
  margin-left: 7px;
  margin-bottom: 1px;
}

.custom-select {
  font-size: 12px;
}

.modal-option {
  text-align: left;
  padding: 15px 25px;
  border-bottom: 1px solid #DDDDDD;
  position: relative;

  &:last-child {
    border-bottom: none;
  }
}

.option-header {
  font-size: 16px;
}

.option-languages {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  font-size: 12px;
  font-weight: 400;
}

.option-languages button {
  background: none;
  border: none;
  color: #999999;
  margin-right: 15px;
  cursor: pointer;
  padding: 0;
}

.selected {
  color: #333333;
  font-weight: 700;

  &::before {
    content: '\2713';
    color: #fff;
    background: #333333;
    font-weight: 300;
    font-size: 14px;
    text-align: center;
    width: 15px;
    height: 15px;
    line-height: 15.5px;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
  }
}

.title-span {
  font-size: 18px;
  font-weight: 500;
}

</style>
